export const businessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  additionalType: "https://schema.org/AutoDrivingSchool",
  name: "Rijschool De Diamant",
  image:
    "https://vibe.filesafe.space/1781862609113466713/attachments/c36d85c1-49ed-4cf3-9e8d-89006f7035ac.png",
  url: "https://rijschooldediamant.nl/",
  telephone: "0172700509",
  email: "info@rijschooldediamant.nl",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Stationsstraat 46",
    postalCode: "2405BN",
    addressLocality: "Alphen aan den Rijn",
    addressCountry: "NL",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 52.1292,
    longitude: 4.6555,
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      opens: "07:00",
      closes: "21:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Sunday"],
      opens: "12:00",
      closes: "21:00",
    },
  ],
  taxID: "NL002320535B37",
  identifier: {
    "@type": "PropertyValue",
    name: "KVK",
    value: "74192450",
  },
  priceRange: "€€",
  areaServed: [
    { "@type": "City", name: "Alphen aan den Rijn" },
    { "@type": "City", name: "Ter Aar" },
    { "@type": "City", name: "Boskoop" },
    { "@type": "City", name: "Nieuwkoop" },
    { "@type": "City", name: "Aarlanderveen" },
    { "@type": "City", name: "Zevenhoven" },
    { "@type": "City", name: "Hazerswoude-Rijndijk" },
    { "@type": "City", name: "Hazerswoude-Dorp" },
    { "@type": "City", name: "Woubrugge" },
    { "@type": "City", name: "Langeraar" },
    { "@type": "City", name: "Koudekerk aan den Rijn" },
    { "@type": "City", name: "Zwammerdam" },
  ],
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "5.0",
    reviewCount: "500",
  },
  review: [
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Dave Galewicz" },
      datePublished: "2026-05-30",
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      reviewBody:
        "In 1 keer geslaagd met behulp van Rijschool de diamant fijne lessen en top instructeurs",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Ivo Van es" },
      datePublished: "2026-05-15",
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      reviewBody:
        "Hele fijne rijschool! Je word gelijk geholpen en met een proefles kun je kijken of het wat voor jou is.",
    },
  ],
};

export const buildBreadcrumbSchema = (
  breadcrumbs: { name: string; url: string }[],
) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: breadcrumbs.map((crumb, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: crumb.name,
    item: crumb.url,
  })),
});
